import { render, staticRenderFns } from "./footers.vue?vue&type=template&id=71a7479c&scoped=true&"
import script from "./footers.vue?vue&type=script&lang=js&"
export * from "./footers.vue?vue&type=script&lang=js&"
import style0 from "./footers.vue?vue&type=style&index=0&id=71a7479c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a7479c",
  null
  
)

export default component.exports